import { render, staticRenderFns } from "./home-v3.vue?vue&type=template&id=fb343700&"
import script from "./home-v3.vue?vue&type=script&lang=js&"
export * from "./home-v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports